<template>
  <div class="backstage-index">
    <div class="head">
      <!-- 布局头部导航栏 -->
      <page-head @loginOut="loginOut"/>
    </div>
    <div class="layout">
      <!-- 布局侧边栏 -->
      <div class="aside">
        <!-- 布局导航栏 -->
        <div class="menu">
          <menu-Layout :menuList="menuList" :isLevelAdmin="isLevelAdmin"/>
        </div>
      </div>
      <div class="right-layout">
        <!-- 面包屑 -->
        <div class="bread-crumb">
          <bread-crumb />
        </div>
        <!-- 顶部导航 -->
        <div class="top-menu" v-show="isShowTopMenu">
          <top-menu />
        </div>
        <!-- 内容区 -->
        <div id="content" class="content" :class="active!=1?'active':''">
          <div id="main" class="main">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHead from "@/components/layout/page-head";
import BreadCrumb from "@/components/layout/bread-crumb";
import MenuLayout from "@/components/layout/Menu";
import TopMenu from "@/components/layout/top-menu";
import { config } from '@/common/js/config.js'
import { deleteToken, deleteAdminType, deleteUserName, deleteIsAdmin, deleteTeamId } from "@/common/js/storage";
export default {
  components: {
    PageHead,
    MenuLayout,
    BreadCrumb,
    TopMenu
  },

  data() {
    return {
      menuList: [
        {
          name: "系统设置",
          url: "/fire/systemIndex",
          img: require('../../assets/menu/system-settings.png'),
          children: [
            {
              name: "成员与部门",
              url: "/fire/systemIndex/staffDepartmentIndex/staff",
              commonUrl: '/fire/systemIndex/staffDepartmentIndex',
              keyword: 'ROLE_UserAndDept'
            },
            {
              name: "模块管理员",
              url: "/fire/systemIndex/module-administrator",
              commonUrl: '/fire/systemIndex/module-administrator',
              keyword: 'ROLE_ModuleAdmin'
            },
            {
              name: "业务角色",
              url: "/fire/systemIndex/roleAuthority",
              commonUrl: '/fire/systemIndex/roleAuthority',
              keyword: 'ROLE_BizRole'
            }
          ]
        },
        {
          name: "报销模块",
          url: "/fire/reimbursementModuleIndex",
          img: require('../../assets/menu/reimbursementModule.png'),
          children: [
            {
              name: "单据查询",
              url: "/fire/reimbursementModuleIndex/billSearchIndex",
              commonUrl: '/fire/reimbursementModuleIndex/billSearchIndex',
              keyword: 'ROLE_OrderReimburseList'
            },
            {
              name: "单据管理",
              url: "/fire/reimbursementModuleIndex/billAdministrationIndex",
              commonUrl: '/fire/reimbursementModuleIndex/billAdministrationIndex',
              keyword: 'ROLE_OrderReimburseManage'
            },
            {
              name: "审批流程管理",
              url: "/fire/reimbursementModuleIndex/approvalIndex",
              commonUrl: '/fire/reimbursementModuleIndex/approvalIndex',
              keyword: 'ROLE_OrderApproveSetting'
            }
          ]
        },
        {
          name: "伙食模块",
          url: "/fire/foodModuleIndex",
          img: require('../../assets/menu/food.png'),
          children: [
            {
              name: "食堂管理",
              url: "/fire/foodModuleIndex/canteenManagementIndex/canteenManagementList",
              commonUrl: '/fire/foodModuleIndex/canteenManagementIndex',
              keyword: 'ROLE_Canteen'
            },
            {
              name: "物料管理",
              url: "/fire/foodModuleIndex/materialManagementIndex/materialManagement",
              commonUrl: '/fire/foodModuleIndex/materialManagementIndex',
              keyword: 'ROLE_Material'
            },
            {
              name: "供应商管理",
              url: "/fire/foodModuleIndex/supplerManagementIndex/supplerManagement",
              commonUrl: '/fire/foodModuleIndex/supplerManagementIndex',
              keyword: 'ROLE_Supplier'
            },
            {
              name: "菜谱管理",
              url: "/fire/foodModuleIndex/menuManagementIndex",
              commonUrl: '/fire/foodModuleIndex/menuManagementIndex',
              keyword: 'ROLE_Menu'
            },
            {
              name: "采购列表",
              url: "/fire/foodModuleIndex/purchaseIndex/purchase",
              commonUrl: '/fire/foodModuleIndex/purchaseIndex',
              keyword: 'ROLE_Purchase'
            },
            {
              name: "外来人员就餐",
              url: "/fire/foodModuleIndex/outsidersIndex/outsiders",
              commonUrl: '/fire/foodModuleIndex/outsidersIndex',
              keyword: 'ROLE_DiningForOutsiders'
            },
            {
              name: "库存管理",
              url: "/fire/foodModuleIndex/inventoryIndex",
              commonUrl: '/fire/foodModuleIndex/inventoryIndex',
              keyword: 'ROLE_StorageManege'
            },
            {
              name: "帮厨管理",
              url: "/fire/foodModuleIndex/kitchenIndex",
              commonUrl: '/fire/foodModuleIndex/kitchenIndex',
              keyword: 'ROLE_HelpChiefManege'
            },
          ]
        },
        {
          name: "资产模块",
          url: "/fire/fixedAssetsIndex",
          img: require('../../assets/menu/assets.png'),
          children: [
            {
              name: "资产列表",
              url: "/fire/fixedAssetsIndex/assetsListIndex/assetsList",
              commonUrl: '/fire/fixedAssetsIndex/assetsListIndex',
              keyword: 'ROLE_PropertyList'
            },
            {
              name: "审批记录",
              url: "/fire/fixedAssetsIndex/approvelRecordIndex/approvelRecord",
              commonUrl: '/fire/fixedAssetsIndex/approvelRecordIndex',
              keyword: 'ROLE_ApplicationPropertyList'
            },
            {
              name: "审批流程管理",
              url: "/fire/fixedAssetsIndex/approvelIndex/approvelApplyIndex",
              commonUrl: '/fire/fixedAssetsIndex/approvelIndex',
              keyword: 'ROLE_PropertyApproveSetting'
            },
          ]
        },
        {
          name: "工薪模块",
          url: "/fire/salaryModuleIndex",
          img: require('../../assets/menu/salary.png'),
          children: [
            {
              name: "审批流程管理",
              url: "/fire/salaryModuleIndex/salaryModuleIApprovelIndex/salaryModuleIApprovel",
              commonUrl: '/fire/salaryModuleIndex/salaryModuleIApprovelIndex',
              keyword: 'ROLE_SalaryApproveSetting'
            },
            {
              name: "工薪模板",
              url: "/fire/salaryModuleIndex/salaryTmpIndex/salaryTmp",
              commonUrl: '/fire/salaryModuleIndex/salaryTmpIndex',
              keyword: 'ROLE_SalaryModule'
            },
            {
              name: "工薪制表",
              url: "/fire/salaryModuleIndex/salaryFormIndex/salaryForm",
              commonUrl: '/fire/salaryModuleIndex/salaryFormIndex',
              keyword: 'ROLE_SalaryTemplate'
            }
          ]
        },
        {
          name: "权威发布模块",
          url: "/fire/authoritativeModuleIndex",
          img: require('../../assets/menu/authoritative.png'),
          children: [
            {
              name: "规制档案馆",
              url: "/fire/authoritativeModuleIndex/archivesIndex/archives",
              commonUrl: '/fire/authoritativeModuleIndex/archivesIndex',
              keyword: ''
            },
            {
              name: "疑难解答",
              url: "/fire/authoritativeModuleIndex/troubleshootingIndex/troubleshooting",
              commonUrl: '/fire/authoritativeModuleIndex/troubleshootingIndex',
              keyword: ''
            },
          ]
        }
      ],
      isShowTopMenu: false,
      isLevelAdmin: 2,
      active: 1
    };
  },

  created() {
    config()
  },
  mounted() {
    this.$bus.on("isShowTopMenu", v =>{
      this.isShowTopMenu = v
    });
    this.$bus.on("isMenuActive", v =>{
      this.active = v
    });
  },

  methods: {
    loginOut() {
      //后财增加退出埋点 20250805
      sensors_sw.logout();
      deleteToken()
      deleteAdminType()
      deleteUserName()
      deleteIsAdmin()
      deleteTeamId()
      this.$router.push('/')
    },
  },
};
</script>

<style lang='scss' scoped>
.backstage-index .layout .right-layout .active {
  padding: 0px;
}
</style>
